export default __webpack_public_path__ + "static/media/logo_falabella.3c6bbbef.png";